module.exports = __webpack_public_path__ + "static/media/galerija_2021 (23)-min.732f8ef1.jpg";